module.exports = __webpack_public_path__ + "img/backfocusing_1000.c0ab43bd.png";